var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 8,
    fill: "#DBDFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 17,
    height: 29,
    rx: 2,
    fill: "#6670FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3421 40H32.6579C33.3978 40 34 39.3901 34 38.6406V12.3594C34 11.6099 33.3978 11 32.6579 11H18.3421C17.6022 11 17 11.6099 17 12.3594V38.6406C17 39.3901 17.6022 40 18.3421 40ZM17.8947 12.3594C17.8947 12.2392 17.9419 12.1239 18.0258 12.039C18.1097 11.954 18.2235 11.9062 18.3421 11.9062H32.6579C32.7765 11.9062 32.8903 11.954 32.9742 12.039C33.0581 12.1239 33.1053 12.2392 33.1053 12.3594V38.6406C33.1053 38.7608 33.0581 38.8761 32.9742 38.961C32.8903 39.046 32.7765 39.0938 32.6579 39.0938H18.3421C18.2235 39.0938 18.1097 39.046 18.0258 38.961C17.9419 38.8761 17.8947 38.7608 17.8947 38.6406V12.3594Z",
    fill: "#6670FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9475 38.1875C26.4416 38.1875 26.8422 37.7818 26.8422 37.2812C26.8422 36.7807 26.4416 36.375 25.9475 36.375C25.4533 36.375 25.0527 36.7807 25.0527 37.2812C25.0527 37.7818 25.4533 38.1875 25.9475 38.1875Z",
    fill: "#DBDFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7101 14.625H27.289C27.4077 14.625 27.5215 14.5773 27.6053 14.4923C27.6892 14.4073 27.7364 14.2921 27.7364 14.1719C27.7364 14.0517 27.6892 13.9364 27.6053 13.8515C27.5215 13.7665 27.4077 13.7188 27.289 13.7188H23.7101C23.5914 13.7188 23.4776 13.7665 23.3937 13.8515C23.3098 13.9364 23.2627 14.0517 23.2627 14.1719C23.2627 14.2921 23.3098 14.4073 23.3937 14.4923C23.4776 14.5773 23.5914 14.625 23.7101 14.625Z",
    fill: "#DBDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceLogo);
export default __webpack_public_path__ + "static/media/deviceLogo.43e143ac26b78e094cdfcaab9c5b8acb.svg";
export { ForwardRef as ReactComponent };